import React from 'react';
import * as S from './Message.styles';
const Message = /*#__PURE__*/React.forwardRef(({
  children,
  orientation,
  messageType = 'error'
}, ref) => {
  const messageIcon = messageType === 'info' ? /*#__PURE__*/React.createElement(S.InfoMessageIcon, {
    variant: "bold"
  }) : /*#__PURE__*/React.createElement(S.ErrorMessageIcon, {
    variant: "bold"
  });
  return /*#__PURE__*/React.createElement(S.MessageContainer, {
    $isHorizontal: orientation === 'horizontal'
  }, messageIcon, /*#__PURE__*/React.createElement(S.MessageRoot, {
    variant: "ui",
    size: "small",
    ref: ref,
    $messageType: messageType
  }, children));
});
export { Message };